import { render, staticRenderFns } from "./VaInput.vue?vue&type=template&id=873b7c86&"
import script from "./VaInput.vue?vue&type=script&lang=js&"
export * from "./VaInput.vue?vue&type=script&lang=js&"
import style0 from "./VaInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports